module.exports = __webpack_public_path__ + "media/components/elements/atoms/CheckBox/icon-checkmark-b72db7d8ad9cd7d0fd12a255f76595f6.svg";